import React, { useMemo } from "react";
import { Chart } from "@payping/web-components";
import { AppLineType } from "@payping/web-components/components/Chart/types";
import { toJalali } from "@payping/utils/dateUtils";
import { DailyReferVM } from "@payping/api";

import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "./styles.module.scss";

interface Props {
  revenueValue?: DailyReferVM[];
}

function appendFaDate(data?: DailyReferVM[]): DailyReferVM[] | undefined {
  if (!data) {
    return undefined;
  }

  return data?.map((record: DailyReferVM) => {
    const axisDate = toJalali({ date: record.payDate, toFormat: "jYYYY/jMM/jDD" }).string;
    const toolTipDate = toJalali({ date: record.payDate, toFormat: "jD jMMMM jYYYY" }).string;

    return { ...record, axisDate, toolTipDate };
  });
}

const ReferralChart: React.FC<Props> = ({ revenueValue }) => {
  const { t } = useAppTranslation();
  const chartColor = "#52C41A";

  /*
  const CustomLegend = () => (
    <Chart.LegendTag
      color={chartColor}
      key={"amount"}
      label={t("referral.income.title")}
      style={{ marginRight: `1vw` }}
    />
  );
*/
  const lineChartData = appendFaDate(revenueValue);

  const lines: AppLineType[] = useMemo(
    () => [
      {
        chartType: "line",
        color: chartColor,
        datatype: "number",
        key: "amount",
        label: t("referral.income.chartTooltipTitle"),
        orientation: "left",
      },
    ],
    [t]
  );

  const fakeData = [];
  for (let i = 0; i < 10; i += 1) {
    fakeData.push({ amount: i * 1_000, time: i });
  }

  return (
    <div className={styles.chart}>
      <Chart
        noDataPlaceholder={t("referral.income.noDataPlaceholder")}
        lines={lines}
        data={lineChartData}
        xDataKey="axisDate"
        loading={false}
      />
    </div>
  );
};

export default ReferralChart;
